import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractBriefReportComponent } from '../pages/contract-brief-report/contract-brief-report.component';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-book-seller-ledger-brief-report-component',
  templateUrl: './book-seller-ledger-brief-report-component.component.html',
  styleUrl: './book-seller-ledger-brief-report-component.component.scss'
})
export class BookSellerLedgerBriefReportComponentComponent {

  contractData = [];
  advtFormBeans:any=[]
  advtVBTotal:number=0;
  advtFormBean:any
  advtBrieflyFormBeans:any=[]
  advtBrieflyTotal: number=0;
  advtMonthwiseFormBeans:any=[]
  GSTfullreportFormBeans:any=[]
  advtMonthwiseTotal:number=0;
  advtOfficierbrieflyFormBeans:any=[]
  advtOfficierbrieflyTotal:number=0;
  advtPaymentRegiInDetailsFormBeans:any=[]
  advtCreditRegiInDetailsFormBeans:any=[]
  advtCreditRegiInBrieflyFormBeans:any=[]
  OutstandingInDetailFormBeans:any=[]
  CreditadvtOffMTotal:number=0;
  CreditadvtOffVBMTotal:number=0;
  OutStandingIDTotal:number=0;
  OutStandingIDNetAmtTotal:number=0;
  OutStandingIDUnPaidTotal:number=0;
  PaymentadvtOffInDFormBenas:any=[]
  CreditadvtOffInDFormBenas:any=[]
  PaymentadvtOffInDTotal:number=0;
  PaymentadvtOffInDTotal2:number=0;
  PaymentadvtOffInDTotal3:number=0;


  startDate:any = '';
  endDate:any = '';
  repName = '';
  offRepName = '';
  bookSellerName = '';
  reportType = '';
  currentDate= new Date();


  getpersonalleddata: any;
  balancecfamt: any;


  getpersonalledBridflydata: any;
  Totalop: number;
  TotalDebit: number;
  TotalCredit: number;
  Totalbal: number;
  TotalCreditTotal: number;
  Totalnet: number;
  Totalrcv: number;
  totalbalance: number;
  show: boolean;

    constructor(
      private dialogRef: MatDialogRef<ContractBriefReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef,private fb: FormBuilder,private datePipe:DatePipe
    ) {
      console.log(this.data)
    
    
    }
    

    ngOnInit(): void {

      this.startDate = this.data['startDate'];
      this.endDate = this.data['endDate'];
      this.bookSellerName = this.data['name']
      this.reportType = this.data['reportType'];

      this.filters()

    }

    filters(){

      let repname:any=this.repName
      if(repname!=""){
        repname=[this.repName]
      }
        const req:any = {
          
          "start_date":this.startDate,
          "end_date":this.endDate,
          "book_seller_name":this.bookSellerName,
          // "issue_name" : this.advtName,
          //"issue_date":this.issueDates
        }
        const req1:any = {
         
          "start_date":this.startDate,
          "end_date":this.endDate,
          "book_seller_name" :this.bookSellerName
  //         "start_date": "2024-04-01",
  // "end_date": "2025-03-31",
  // "book_seller_name": "सुहास शरद मुंडले"
        }
        // persoanl ledger
        this.service.getBookSellerLedgerData(req1).subscribe((data: any) => { 
          debugger
          console.log("Get ledgerdata",data)
            this.getpersonalleddata = data as any;  
            this.balancecfamt =this.getpersonalleddata[0].opening_bal;
      
            // for(let data1 of this.getpersonalleddata[0].rep_data){
             
            //     if(data1.net_amt!= null && data1.net_amt!= "" ){
            //       this.balancecfamt=parseFloat(data1.net_amt)+parseFloat(this.balancecfamt)
            //       data1.rem_amount=this.balancecfamt
            //       data1.act_amt=null
                  
            //      }else{
                 
            //       data1.act_amt=parseFloat(this.balancecfamt)-parseFloat(data1.actual_arc_amt)
            //       if(data1.credit_amt!= null && data1.credit_amt!= "" ){
            //         data1.rem_amount=parseFloat(data1.act_amt)-parseFloat(data1.credit_amt)
            //         this.balancecfamt=data1.rem_amount
            //       }else{
            //         this.balancecfamt=data1.act_amt
            //       }
            //      }
            // }
            for (let data1 of this.getpersonalleddata[0].rep_data) {
    
              if (data1.net_amt !== null && data1.net_amt !== "") {
                  this.balancecfamt = parseFloat(data1.net_amt) + parseFloat(this.balancecfamt);
                  data1.act_amt = this.balancecfamt;
                  debugger;
          
              } else if (data1.actual_arc_amt !== null && data1.actual_arc_amt !== "") {
                  data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.actual_arc_amt);
                  this.balancecfamt = data1.act_amt;
                  debugger;
          
              } else if (data1.credit_amt !== null && data1.credit_amt !== "") {
                  data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.credit_amt);
                  this.balancecfamt = data1.act_amt;
              }
          
              // data1.rem_amount = this.balancecfamt;
          }
          
        });


        this.service.getBookSellerLedgerBriefly(req).subscribe((data: any) => {
          console.log("Get ledgerdata brifly", data);
          this.getpersonalledBridflydata = data as any;  
        
          // Initialize totals
          this.Totalop = 0;
          this.Totalnet = 0;
          this.Totalrcv = 0;
          this.TotalCreditTotal = 0;
          this.TotalCredit = 0;
          this.Totalbal = 0;
          this.totalbalance = 0;
        
          for (let data of this.getpersonalledBridflydata) {
            this.Totalop += parseFloat(data.opening_bal) || 0;
            this.Totalnet += parseFloat(data.net_amt) || 0;
            this.Totalrcv += parseFloat(data.rcv_amt) || 0;
            this.TotalCredit += parseFloat(data.credit_amt) || 0;
            this.TotalCreditTotal += parseFloat(data.total_received_amt) || 0;
            this.Totalbal += parseFloat(data.bal_amt) || 0;
            // this.totalbalance += parseFloat(data.bal_amt) || 0;  
          }
        });
        


        
        
       
     
      
      
      }
// fileNamee = 'BookSheet.xlsx';
 exportExcel(fileName: string) {
  let element = document.getElementById('print-section');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  // Loop through each cell and format date columns
  Object.keys(ws).forEach((key) => {
    if (key[0] === '!') return; // skip meta keys like !ref, !cols
    const cell = ws[key];
    if (cell.t === 'd' || (cell.t === 'n' && cell.z && cell.z.includes('m'))) {
      // force only date format (dd-mm-yyyy or yyyy-mm-dd)
      cell.z = 'dd-mm-yyyy';
    }
  });

  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, fileName + '.xlsx');
}


   printPageA4Landscape() {
  this.show = true;
  const printSection = document.getElementById('print-section');
  if (!printSection) {
    console.error("Print section not found!");
    return;
  }

  const printContent = printSection.innerHTML;
  const screenWidth = window.screen.availWidth;
  const windowWidth = 1000;
  const leftPosition = screenWidth - windowWidth - 50;

  const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A4 landscape;
                margin: 5mm;
              }

              body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              /* Prevent duplicate headers */
              thead {
                display: table-header-group;
              }
              tfoot {
                display: table-footer-group;
              }

              /* Table styles */
              table {
                border-collapse: collapse;
                width: 100% !important;
                font-size: 10pt;
                page-break-inside: auto;
              }

              th, td {
                border: 1px solid black !important;
                padding: 3px 5px !important;
                white-space: nowrap;
                text-align:end;
              }

              /* Ensure no page breaks inside rows */
              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }
                 .br-right-4 {
                border-right: 3px solid black !important;
              }

              /* Scale down if needed */
              @page :footer {
                display: none;
              }
              @page :header {
                display: none;
              }

              /* Hide non-print elements */
              .noPrint {
                display: none !important;
              }
            }

            @media screen {
              body {
                background-color: #f1f1f1;
                margin: 0;
                padding: 20px;
              }
              
              .print-section {
                background: white;
                box-shadow: 0 0 5px rgba(0,0,0,0.1);
                padding: 20px;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-section">${printContent}</div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 500);
              }, 200);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

printPageA4Portrait() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
        console.error("Print section not found!");
        return;
    }
  
    const printContent = printSection.innerHTML;
  
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;
  
    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
  
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page {
                                size: A4 portrait;
                                margin: 15mm;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                margin: 0;
                                padding: 0;
                                font-size: 13px !important;
                            }
                            .print-section {
                                width: 100%;
                                margin: 0 auto;
                                padding: 0;
                            }
                            table {
                                width: auto !important;
                                border-collapse: collapse;
                                table-layout: auto;
                                page-break-inside: auto;
                                border: 1px solid black !important;
                            }
                            tr {
                                page-break-inside: avoid;
                                page-break-after: auto;
                            }
                            th, td {
                                padding: 2px 3px !important;
                                border: 1px solid black !important;
                                font-size: 13px;
                                line-height: 1.2;
                                white-space: nowrap;
                            }
                            th {
                                background-color: #f2f2f2;
                                font-weight: bold;
                            }
                            tr {
                                border-bottom: 1px solid black !important;
                            }
                            tr.header-row {
                                display: table-header-group;
                            }
                            td[data-type="number"],
                            td.amount,
                            td.balance-value,
                            td:nth-child(n+12) {
                                text-align: right !important;
                            }
                            td.text,
                            td[data-type="string"] {
                                text-align: left !important;
                            }
                            .br-right { border-right: 1px solid black !important; }
                            .br-rightt { border-right: 3px solid black !important; }
                            .br-bottom { border-bottom: 2px solid black !important; }
                            .br-top { border-top: 2px solid black !important; }
                            .noPrint { display: none !important; }
                            .footer-line {
                                position: fixed;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 1px;
                                background-color: black;
                            }
                            thead { 
                                display: table-header-group; 
                                border: 1px solid black !important;
                            }
                            tfoot { 
                                display: table-footer-group; 
                                border: 1px solid black !important;
                            }
                            /* Ensure all borders are displayed */
                            table, th, td {
                                border-style: solid !important;
                                border-width: 1px !important;
                                border-color: black !important;
                            }
                            /* Make sure header repeats on each page */
                            thead tr {
                                display: table-row !important;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div class="print-section">
                        ${printContent}
                        <div class="footer-line"></div>
                    </div>
                    <script>
                       window.onload = function () {
                           const table = document.querySelector('table');
                           if (!table) {
                               console.error("Table not found");
                               return;
                           }

                           // Auto-size columns based on content
                           table.style.width = 'auto';
                           const cols = table.querySelectorAll('td, th');
                           cols.forEach(cell => {
                               cell.style.width = 'auto';
                               cell.style.whiteSpace = 'nowrap';
                           });

                           let headerRowIndex = -1;
                           const maxRowsToCheck = Math.min(10, table.rows.length);

                           // Find header row with column names
                           for (let i = 0; i < maxRowsToCheck; i++) {
                               const row = table.rows[i];
                               const cellTexts = Array.from(row.cells).map(cell => cell.textContent.trim());

                               if (row.cells.length >= 8 &&
                                   (cellTexts.includes('Invoice No') ||
                                    cellTexts.includes('Receipt No') ||
                                    cellTexts.includes('Balance'))) {
                                   headerRowIndex = i;
                                   break;
                               }
                           }

                           if (headerRowIndex >= 0) {
                               // Create thead and move only the actual header row into it
                               let thead = table.querySelector('thead');
                               if (!thead) {
                                   thead = document.createElement('thead');
                                   table.insertBefore(thead, table.firstChild);
                               }

                               const headerRow = table.rows[headerRowIndex];
                               thead.appendChild(headerRow.cloneNode(true));
                           }

                           // Alignment processing
                           const cells = document.querySelectorAll('td');
                           cells.forEach(cell => {
                               const content = cell.textContent.trim();

                               if (content.includes('येणे') ||
                                   content.includes('Opening Balance') ||
                                   content.match(/^\\d+\\s+येणे$/) ||
                                   content.includes('Balance C/F') ||
                                   content.includes('Total')) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('balance-value');
                               }

                               const numericPattern = /^-?\\d+(,\\d{3})*(\\.\\d+)?$/;
                               if (numericPattern.test(content.replace(/[\\s,]/g, ''))) {
                                   cell.style.textAlign = 'right';
                                   cell.classList.add('amount');
                               }

                               cell.style.border = '1px solid black';
                           });

                           setTimeout(() => {
                               window.print();
                               setTimeout(() => { window.close(); }, 500);
                           }, 200);
                       };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}


// const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
//   .map(node => node.outerHTML)
//   .join('\n');

      
}
